import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-stock-filter',
  templateUrl: './stock-filter.component.html',
  styleUrls: ['./stock-filter.component.css']
})
export class StockFilterComponent implements OnInit {

  myControl = new FormControl();

  @Input('type') type: string;
  @Output() report_result = new EventEmitter<object>();

  itemCats = [];
  all_itemSubCats = [];
  itemSubCats = [];
  branchList = [];
  storeList = [];
  allStoreList = [];
  result = { 'branch_id': '', 'branch_name': '', 'brnach_name_en': '', 'store_id': '', 'store_name': '', 
    'store_name_en': '', 'sub_item_name': '', 'by_detail': '0', 'list': [] };

  model = { 'table_name': 'stock', 'item_cat_id': '0', 'item_subcat_id': '0', 'branch_id': '0', 
    'store_id': '0', 'sub_item_no': '', 'transfer_type': 'sent' };

  search_obj = {
    'placeholder': 'اسم/ رقم الصنف', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'sub_item_no',
      'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`',
      'join_field_list': ['sub_item_no'],
      'join_condition': ' AND `main_item`.`main_item_id` = `sub_item`.`main_item_id`'
    }]
  };

  Sub_item_Placeholder; Branch_Msg; Store_Msg; Main_Cat_Msg; 
  // Sub_Item_Msg;

  constructor(public applicationConstants: ApplicationConstants, private utils: Utils, 
    private queryList: QueryList, public translate: TranslateService) { 
    this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Sub_item_Placeholder').subscribe((res: string) => {
      this.Sub_item_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Sub_item_Placeholder;

    translate.get('Branch_Msg').subscribe((res: string) => {
      this.Branch_Msg = res;
    });

    translate.get('Store_Msg').subscribe((res: string) => {
      this.Store_Msg = res;
    }); 

    translate.get('Main_Cat_Msg').subscribe((res: string) => {
      this.Main_Cat_Msg = res;
    }); 

    // translate.get('Sub_Item_Msg').subscribe((res: string) => {
    //   this.Sub_Item_Msg = res;
    // });
  }

  ngOnInit() {
    let query, obj;
    
    query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'اختر', 'branch_name_en': 'Select' });
      });

    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE " +
      "`branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "' " +
      "AND `branch_auth`.`status` = '1' AND `branch_auth`.`branch_id` = `store`.`branch_id` AND " +
      "`store`.`status` = '1' AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allStoreList = data.data['list'];
      });
  
    query = this.queryList.all_itemCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.itemCats = data.data['list'];
        this.itemCats.unshift({ 'item_cat_id': '0', 'item_cat_name': 'اختر', 'item_cat_name_en': 'Select' });
      });
  
    query = this.queryList.all_itemSubCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_itemSubCats = data.data['list'];
      });
  
  }

  getSubCat() {
    this.itemSubCats = [{ 'item_subcat_id': '0', 'item_subcat_name': 'اختر', 'item_subcat_en': 'Select' }];
    this.model['item_subcat_id'] = '0';

    this.all_itemSubCats.forEach(element => {
      if (element.item_cat_id == this.model['item_cat_id'])
        this.itemSubCats.push(element);
    });
  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'اختر', 'store_name_en': 'Select' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '0') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });
    }
  }

  onChangeSearch = function (search_result: object) {
    console.log(search_result);
    this.model['sub_item_no'] = search_result['no'];
  }

  search() {
    if (this.model['branch_id'] == '0') {
      alert(this.Branch_Msg);
      return false;
    }

    if (this.model['store_id'] == '0') {
      alert(this.Store_Msg);
      return false;
    }
    
    if (this.model['sub_item_no'] == '' && this.model['item_cat_id'] == '0') {
      alert(this.Main_Cat_Msg);
      return false;
    }

    // if (this.type == 'stock_report' && 
    //   (document.getElementById('by_detail') as HTMLInputElement).checked && this.model['sub_item_no'] == '') {
    //   alert(this.Sub_Item_Msg);
    //   return false;
    // }
   
    let obj;
    if (this.type == 'stock_list' || this.type == 'stock_report') 
      obj = { cmd: 'getSubCatSubItem', store_id: this.model['store_id'], stock: true };
    else if (this.type == 'damage_list') 
      obj = { cmd: 'getStockDamageList', store_id: this.model['store_id'] };
    else if (this.type == 'transfer_list') 
      obj = { cmd: 'getStockTransferList', transfer_type: this.model['transfer_type'], 
        store_id: this.model['store_id'] };

    if (this.type == 'stock_report' && (document.getElementById('by_detail') as HTMLInputElement).checked)
      obj['by_detail'] = true;

    if (this.model['sub_item_no'] != '') 
      obj['sub_item_no'] = this.model['sub_item_no'];
    else {
      if (this.model['item_subcat_id'] != '0')
        obj['item_subcat_id'] = this.model['item_subcat_id'];
      else if (this.model['item_cat_id'] != '0')
        obj['item_cat_id'] = this.model['item_cat_id']; 
    }
    
    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.result['list'] = data.data['list'];

        this.branchList.forEach(element => {
          if (element.branch_id == this.model['branch_id']) {
            this.result['branch_id'] = this.model['branch_id'];
            this.result['branch_name'] = element.branch_name;
            this.result['brnach_name_en'] = element.brnach_name_en;
          }
        });
 
        this.storeList.forEach(element => {
          if (element.store_id == this.model['store_id']) {
            this.result['store_id'] = this.model['store_id'];
            this.result['store_name'] = element.store_name;
            this.result['store_name_en'] = element.store_name_en;
          }
        });

        if (this.model['sub_item_no'] != '')
          this.result['sub_item_name'] = (document.getElementById('search_value_0') as HTMLInputElement).value;

        if (this.type == 'stock_report')
          this.result['by_detail'] = ((document.getElementById('by_detail') as HTMLInputElement).checked ? '1' : '0');

        this.report_result.emit(this.result);
      });
  }
}
